import { Call } from "@closerplatform/closer-sdk";
import { AbstractCallService, UserCallInfo } from "@fidget/common/services/AbstractCallService";
import { ArtichokeService } from "@fidget/common/services/artichokeService";
import { logger } from "@fidget/common/utils";
import { IForeSpinnerService } from "./spinnerService";

export class ForeCallService extends AbstractCallService {
  private spinnerService: IForeSpinnerService;

  constructor(spinnerService: IForeSpinnerService, artichokeService: ArtichokeService) {
    super(artichokeService);
    this.spinnerService = spinnerService;
  }

  protected handleCallEnded(call: Call): void {
    return;
  }

  public async connect(agentId: string, audioTrack: MediaStreamTrack): Promise<UserCallInfo> {
    logger.debug("CallService: calling to agent", agentId);
    if (this.currentCall) {
      throw new Error("Can't call, there is a call in progress already");
    }

    const deviceId = await this.artichokeService.getDeviceId();
    if (!deviceId) {
      logger.error("There is no deviceId, could not create a call");
    }
    const call = await this.spinnerService.createCall(deviceId || "", agentId);
    const ratelCall = await this.artichokeService.getCall(call.id);
    this.handleNewCall(ratelCall);
    ratelCall.addTracks([audioTrack]);
    this.currentLocalAudioTrack = audioTrack;
    return { callId: ratelCall.id, remoteUserId: agentId };
  }
}
